<script>
  import { chart } from "svelte-apexcharts";
  export let total_incidents_by_all;
  export let total_incidents;
  export let loading;

  let options = {
    chart: {
      type: "area",
      height: 120,
      // sparkline: {
      //   enabled: true
      // },
      animations: {
        speed: 800
      },
      toolbar: {
        show: false
      },
      zoom: {
        enabled: false
      }
    },
    stroke: {
      width: 1
    },
    colors: ["#8C969C"],

    series: [
      {
        name: "Incidents",
        data: total_incidents
      }
    ],
    xaxis: {
      type: "datetime",
      labels: {
        show: true,
        style: {
          colors: "#aCb6bC"
        }
      },
      axisBorder: {
        show: false
      }
    },
    yaxis: {
      labels: {
        show: false
      },
      axisTicks: {
        show: false
      },
      min: 0
    },
    dataLabels: {
      enabled: false
    },
    grid: {
      show: false
    },
    legend: {
      position: "bottom",
      itemMargin: {
        //   horizontal: 0,
        vertical: 25
      }
      // offsetY: -54
      // markers: {
      //   width: 0,
      //   height: 0
      // }
    }
  };

  let incidents = total_incidents;
  let options2;

  $: {
    // let t = "datetime";
    switch (duration) {
      case "week":
        incidents = total_incidents.slice(0, 7);
        total_incidents_by = total_incidents_by_all.slice(0, 7);
        break;
      case "month":
        incidents = total_incidents.slice(0, 30);
        total_incidents_by = total_incidents_by_all.slice(0, 30);

        break;
      case "ninetydays":
        incidents = total_incidents.slice(0, 90);
        total_incidents_by = total_incidents_by_all.slice(0, 90);

        break;
      case "overall":
        // t = "category";
        incidents = total_incidents;
        total_incidents_by = total_incidents_by_all;

        break;
      default:
        incidents = total_incidents;
        total_incidents_by = total_incidents_by_all;
    }
    // options.xaxis.type = t;
    options.series[0].data = incidents;

    total_incidents_by_taliban = total_incidents_by.map(itm => {
      return {
        x: itm.x,
        y: parseInt(itm["Taliban"]) || 0
      };
    });
    total_incidents_by_andsf = total_incidents_by.map(itm => {
      return {
        x: itm.x,
        y: parseInt(itm["ANDSF"]) || 0
      };
    });
    total_incidents_by_others = total_incidents_by.map(itm => {
      return {
        x: itm.x,
        y: parseInt(itm["Others"]) || 0
      };
    });
    total_incidents_by_nato = total_incidents_by.map(itm => {
      return {
        x: itm.x,
        y: parseInt(itm["US-Led Coalition"]) || 0
      };
    });

    let series = [
      { name: "Taliban", data: total_incidents_by_taliban },
      { name: "ANDSF", data: total_incidents_by_andsf },
      { name: "US-Led Coalition", data: total_incidents_by_nato },
      { name: "Others", data: total_incidents_by_others }
    ];
    let tmp_options = {
      ...options,
      chart: { ...options.chart, height: 250 },
      // colors: ["#22332288", "#00aa3388", "#3366ee88", "#eeaa3388"],
      colors: ["#223322aa", "#00d386ee", "#008ffbee", "#ff4560"],
      // colors: undefined,
      stroke: { width: 0 },
      // fill: {
      //   type: "gradient",
      //   gradient: {
      //     shadeIntensity: 1,
      //     opacityFrom: 0.7,
      //     opacityTo: 0.9,
      //     stops: [0, 100]
      //   }
      // },
      fill: {
        type: "solid"
      },
      // theme: { palette: "palette1" },
      series: series
    };
    options2 = tmp_options;
  }

  let total_incidents_by = total_incidents_by_all;

  let total_incidents_by_taliban;
  let total_incidents_by_andsf;
  let total_incidents_by_others;
  let total_incidents_by_nato;

  $: incidents_total = incidents.reduce((v, itm) => v + parseInt(itm["y"]), 0);

  $: total_incidents_by_taliban_val = total_incidents_by_taliban.reduce(
    (v, itm) => v + parseInt(itm["y"]),
    0
  );
  $: total_incidents_by_andsf_val = total_incidents_by_andsf.reduce(
    (v, itm) => v + parseInt(itm["y"]),
    0
  );
  $: total_incidents_by_others_val = total_incidents_by_others.reduce(
    (v, itm) => v + parseInt(itm["y"]),
    0
  );
  $: total_incidents_by_nato_val = total_incidents_by_nato.reduce(
    (v, itm) => v + parseInt(itm["y"]),
    0
  );

  $: if (expanded != null) {
    options = options;
  }

  export let expanded;
  export let duration;
</script>

<h1
  style={expanded ? 'margin-top:20px; width: 380px;' : 'margin-top: -40px; width: 180px;'}>
  Incidents Timeline
  {#if expanded}
    <span class="subheading">
      {#if duration == 'week'}Last 7 Days{/if}
      {#if duration == 'month'}Last 30 Days{/if}
      {#if duration == 'ninetydays'}Last Ninety Days{/if}
      {#if duration == 'overall'}Overall Incidents{/if}
    </span>
  {/if}
</h1>

{#if expanded}
  <div style="display:flex;" class="two_grpahs">
    <div style="background:#ff00; min-width:260px;">
      <div class="bold" style="margin-top:30px; margin-left:20px;">
        Attack Initiated By:
      </div>

      <div
        class="flags_expanded"
        style=" align-items: center;margin-top:10px; margin-left: 60px;width:
        178px;float:left;">
        <div class="flag taliban">
          <div
            class="pc"
            style={'width:' + parseInt((total_incidents_by_taliban_val / incidents_total) * 100) + 'px'} />
          <img src="images/taliban.png" alt="" />
          <div class="flag_val">{total_incidents_by_taliban_val}</div>
        </div>
        <div class="flag afg">
          <div
            class="pc"
            style={'width:' + parseInt((total_incidents_by_andsf_val / incidents_total) * 100) + 'px'} />
          <img src="images/afg.png" alt="" />
          <div class="flag_val">{total_incidents_by_andsf_val}</div>

        </div>
        <div class="flag nato">
          <div
            class="pc"
            style={'width:' + parseInt((total_incidents_by_nato_val / incidents_total) * 100) + 'px'} />
          <img src="images/nato.png" alt="" />
          <div class="flag_val">{total_incidents_by_nato_val}</div>

        </div>

        <div class="flag others">
          <div
            class="pc"
            style={'width:' + parseInt((total_incidents_by_others_val / incidents_total) * 100) + 'px'} />
          <img src="images/afg.png" alt="" />
          <div class="flag_val">{total_incidents_by_others_val}</div>

        </div>

      </div>

    </div>
    <div style="margin-top:80px; width:100%; " use:chart={options2} />
  </div>
{:else}
  <div class="expand" style="height:32px;">
    <img width="32px" height="32px" src="images/expand.png" alt="" />
  </div>
{/if}
<div>
  {#if !expanded}
    <div
      style="margin-left: 30px; padding-top: 26px; min-width: 140px;float:left;">
      <div class="bold" style=" margin-bottom: 4px;">
        {#if duration == 'week'}Last 7 Days{/if}
        {#if duration == 'month'}Last 30 Days{/if}
        {#if duration == 'ninetydays'}Last Ninety Days{/if}
        {#if duration == 'overall'}Overall{/if}
      </div>
      <div class="medium">Total Incidents</div>
      <div
        class="attacks_num"
        style="font-family: Georgia; font-size: 20pt; font-weight: bold; color:
        #cb001c;">
        {incidents_total}
      </div>
    </div>
    <div
      class="flags"
      style="display: flex; align-items: center; margin-left: 30px; display:none;
      margin-top:20px; width: 178px;float:left;">
      <img src="images/afg.png" alt="" />
      <img src="images/taliban.png" alt="" />
      <img src="images/nato.png" alt="" />
    </div>
  {/if}
  <div style="display:flex;">
    {#if expanded}
      <div
        style=" min-width:240px; display:flex; align-items: center;
        margin-left:20px;">
        <div class="bold">Total Attacks</div>
        <div
          style="margin-left:50px; font-family: Georgia; font-size: 16pt;
          font-weight: bold; color: #cb001c;">
          {incidents_total}
        </div>
      </div>
    {/if}
    {#if loading}
      <div style=" padding-top:30px; margin:0 auto;">
        <div class="loader" />
      </div>
    {:else}
      <div class="bars">
        <div style=" width:100%; " use:chart={options} />
      </div>
    {/if}
  </div>
</div>
